<template>
  <section class="component-section" v-if="get(movie,'tr')">
    <div class="container">
      <div class="trailer" v-lazy:background-image="get(movie,'ga[0].u') || get(movie,'m.u')">
        <youtube :videoId="get(movie,'tr')" :extraprivacy="true" v-if="visible" width="100%" height="100%"/>
        <h3>Trailer</h3>
        <div class="play-button" @click="playVideo()" v-if="!visible">
          <strong>Trailer abspielen</strong>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Youtube from '@/components/elements/Youtube.vue';
import { get } from 'lodash-es'

export default {
  components: { Youtube },
  props: ['movie'],
  data () {
    return {
        visible:false,
    }
  },
  methods: {
    get: get,
    playVideo:function(){
      this.$event.$emit('userinteraction', {item:'trailer play', label:'trailer abspielen', from:this.$route.path});
      if(!this.visible) {
        window.open("https://www.youtube.com/watch?v="+this.get(this.movie,'tr'), '_blank');
      }
    }
  },
  mounted:function(){
    window.consent.subscribe('marketing').then(() => {
      this.visible = true
    });
    // if(localStorage.getItem('data-privacy')==='true') this.visible = !this.visible;
  }
}
</script>

<style lang="scss" scoped>
@import "@/sass/_variables.scss";

.component-section {
  padding:0 0 5em 0;
  background-color:white;
  width:100%;
  position: relative;

  &.full-screen{
    height:100%;
    padding: 0;
    .container{
      width:100%;
      height:100%;
      margin:0;
      .trailer{
        height:100%;
      }
      h3{display: none;}
    }
  }

  .container {
    width: 90%;
    margin-left: auto;
    position: relative;
    background-color: inherit;

    .trailer {
      background-color:black;
      position: relative;
      height: 70vh;
      min-height: 400px;
      background-position: center;
      background-size: cover;
      h3 {
        color: black;
        background-color:white;
        position: absolute;
        padding: 0 0.8em 0.4em 0.8em;
        font-family: $font-semi-condensed;
        font-weight: 900;
        font-style: normal;
        font-size: 3em;
        top:-5%;
        right:0;
        @include for-size(phone-only) {
          font-size: 2.5em;
        }
      }
      .play-button {
        position: absolute;
        left:0;
        top: calc(50% - 3vw);
        cursor: pointer;
        min-width: 100%;
        @include for-size(phone-only) {
          top: calc(50% - 10vw);
        }
        strong {
          color:white;
          font-family: $font-semi-condensed;
          font-size:1.5em;
          margin-left:5%;
          vertical-align: middle;
          transition: all 1s ease;
          white-space: nowrap;
        }
        &:before{
          content:"";
          background-color: white;
          background-image: url(/static/img/play.svg);
          background-position: 50% center;
          background-size: auto 55%;
          background-repeat: no-repeat;
          display: inline-flex;
          width: 6vw;
          height: 6vw;
          @include for-size(phone-only) {
            width: 25vw;
            height: 25vw;
          }
          justify-content: center;
          align-items: center;
          transition: all 1s ease;
        }
        &:hover {
          &:before{
            width: 7vw;
            background-position: 100% center;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/modules/Movie/Trailer.vue